import api from "services/api";

interface ISimpleHttpType {
  id: number;
  customerId: number;
  name: string;
  active: boolean;
  device: string | null;
  ip: string | null;
  logPoliceUnitId: number;
  logUserId: number;
}

interface IParam {
  endPoint: string;
  object: ISimpleHttpType;
}

interface IReturnSimpleForm {
  data: number;
  ok: boolean;
  errors: [];
  message: string;
}

export const formPostService = {
  postSimpleForm: async ({ endPoint, object }: IParam) => {
    try {
      const data: IReturnSimpleForm = await api.post(endPoint, object);

      return data;
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
  putSimpleForm: async ({ endPoint, object }: IParam) => {
    try {
      const data: IReturnSimpleForm = await api.put(endPoint, object);

      return data;
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
};
